import { Injectable } from '@angular/core';
import { SubscribedSku } from '@microsoft/microsoft-graph-types-beta';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { skipUntilTenantLoaded } from 'projects/angular-clarity/src/app/services/blob.service';
import { TenantAjaxService } from 'projects/angular-clarity/src/app/services/ajax/tenant-ajax.service';

@Injectable()
export class GraphSubscribedSkusEffects {
    loadGraphSubscribedSkus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadSubscribedSkus),
            // distinct(action => action._tenant), // could reload it for the same tenant after assign any license
            skipUntilTenantLoaded(this.store),
            mergeMap(({ _tenant }) =>
                this.get(_tenant).pipe(
                    map((data) => actions.loadSubscribedSkusSuccess({ _tenant, skus: data.value })),
                    catchError((error) => of(actions.loadSubscribedSkusFailure({ _tenant, error }))),
                ),
            ),
        ),
    );

    private get(tenant: string) {
        return this.ajax.get<{ value: SubscribedSku[] }>(tenant, '/api/microsoft/graph/subscribedSkus');
    }

    constructor(
        private actions$: Actions,
        private ajax: TenantAjaxService,
        private store: Store,
    ) {}
}
